import Render from '@Views/components/layout/container.html'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Render
@Component({})
export class Container extends Vue {

    @Prop({default: false}) loading: boolean
    @Prop({default: "chargement"}) loadingTitle: string
}